export default __webpack_public_path__ + "static/MediaContentSixTeen-cccd101dd356bcfdd8fb889f3b62aeec.webp";